export default __webpack_public_path__ + "static/media/classic03.3061c53a.png";